import { Box, Typography } from '@mui/material';
import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { Badge } from '../../../Logo/Badge';
import { Slideshow } from '../../../Slideshow';
import { StructuredContentRenderer } from '../..';

type Props = StructuredContentDocument<{
  children: StructuredContentDocument[];
  question: string;
}>;

export function FirstPersonPerspective({ props }: Props) {
  const { question, children: perspectiveItems } = props;

  const hasOnlyOneChild = perspectiveItems.length <= 1;

  return (
    <>
      <Box sx={{ marginBottom: 1 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            columnGap: 2,
            paddingBottom: 2,
          }}
        >
          <Badge sx={{ width: 27, height: 27 }} />
          <Typography
            variant="bodySmallBold"
            sx={{
              textTransform: 'uppercase',
              letterSpacing: '.11rem',
            }}
          >
            More Nerdy Perspective{hasOnlyOneChild ? '' : 's'}
          </Typography>
        </Box>
        {question && <Typography variant="bodyLarge">{question}</Typography>}
      </Box>
      <Slideshow>
        {perspectiveItems.map((item, index) => {
          return <StructuredContentRenderer key={index} doc={item} />;
        })}
      </Slideshow>
    </>
  );
}
